// Globals
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledContainer } from './PricesContainerStyles';

// Modules
import {
  AppraiserPricesContainer,
  DocumentPricesContainer,
  PhotoShootingPricesContainer,
  SettlementDataContainer,
} from '@/modules/Prices';
import { SettingsSidebar } from '@/modules/SettingsCommon';

// Helpers
import { PricesTabs } from '../../helpers';

const tabsConfig = {
  [PricesTabs.APPRAISER]: <AppraiserPricesContainer />,
  [PricesTabs.PHOTO_SHOOTING]: <PhotoShootingPricesContainer />,
  [PricesTabs.DOCUMENTS]: <DocumentPricesContainer />,
  [PricesTabs.SETTLEMENT]: <SettlementDataContainer />,
};

const PricesContainer = () => {
  const [activeTab, setActiveTab] = useState<string>(PricesTabs.APPRAISER);
  const { t } = useTranslation('prices');

  return (
    <StyledContainer>
      <SettingsSidebar
        items={[
          {
            key: PricesTabs.APPRAISER,
            label: t('tab_appraiser'),
          },
          {
            key: PricesTabs.PHOTO_SHOOTING,
            label: t('tab_photoshooting'),
          },
          {
            key: PricesTabs.DOCUMENTS,
            label: t('tab_documents'),
          },
          {
            key: PricesTabs.SETTLEMENT,
            label: t('tab_settlement'),
          },
        ]}
        activeKey={activeTab}
        onChange={setActiveTab}
      />

      {tabsConfig[activeTab as keyof typeof tabsConfig]}
    </StyledContainer>
  );
};

export default PricesContainer;
